/** Spinner — respects `prefers-reduced-motion` via styles.css. */
export function Spinner({ label = 'Loading' }: { label?: string }): React.JSX.Element {
  return (
    <div
      className="empty-state"
      role="status"
      aria-live="polite"
      style={{ padding: 'var(--sp-xl)' }}
    >
      <span className="spinner" aria-hidden="true" />
      <span>{label}…</span>
    </div>
  );
}
